




import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomImage extends ComponentVue {
  @Prop({ type: String })
  file!: string

  @Prop({ type: Number, default: 100 })
  width!: number

  @Prop({ type: Number, default: 100 })
  height!: number

  get filePath(): string {
    return '/images/' + this.file
  }
}
